<template>
	<div class="w-full">
		<div class="rounded-lg">
			<div class="mb-4">
				<!-- Cart Items -->
				<div v-for="p in displayedProducts" :key="p.id" class="flex flex-col w-full justify-between py-2 px-4 border-ihh-gray/40">
					<div class="">
						<div class="flex w-full items-center">
							<div class="justify-center text-center mr-6">
								<div class="flex justify-center items-center space-x-8 shrink-0 w-[70px] h-[70px]">
									<img :src="p.img" class="w-[70px] h-[70px] object-contain" />
								</div>
							</div>
							<div class="flex flex-col w-full gap-y-2">
								<div class="w-full flex justify-between text-ihh-midnight-gray text-sm">
									<div class="flex flex-wrap line-clamp-2 max-w-[164px]">{{ p?.quantity || p?.qty }} x {{ p.name }}</div>
									<div>${{ ((p?.priceExTax || parseFloat(p?.basePrice)) * (p?.quantity || p?.qty)).toFixed(2) }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- See All/Less Button -->
				<div class="flex w-full justify-center border-ihh-gray/40" v-if="order?.products?.length > 4">
					<button
						@click="handleShowFullCart"
						class="hover:bg-ihh-gray/10 hover:border-ihh-midnight-gray/50 flex my-5 items-center text-center text-sm text-ihh-midnight-gray border rounded-sm border-ihh-gray/50 py-1 px-4"
					>
						{{ showFullCart ? 'See Less' : 'See All' }}
						<span
							class="flex-inline m-auto items-center justify-center text-center transition duration-100 ease-in-out group"
							:class="{ 'rotate-180 pb-1': showFullCart }"
						>
							<svg class="w-6 h-6" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
								<polygon points="50,70 30,50 35,45 50,60 65,45 70,50" class="fill-ihh-gray" />
							</svg>
						</span>
					</button>
				</div>
			</div>
		</div>

		<div class="flex flex-col text-ihh-midnight-gray font-normal px-2 py-4 border-b border-t">
			<!-- Subtotal -->
			<div class="flex justify-between text-sm mb-1">
				<span>Subtotal</span>
				<span>{{ parseFloat(order?.subtotalExTax)?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
			</div>

			<!-- Gift Certificate Balance -->
			<div v-if="parseFloat(order?.giftCertificateAmount) > 0" class="flex justify-between text-sm my-1">
				<div class="space-x-1">
					<span>Gift Certificate</span>
				</div>
				<div>
					<span v-if="order?.giftCertificateAmount > 0"
						>-{{ parseFloat(order?.giftCertificateAmount)?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span
					>
					<span v-else>{{ parseFloat(order?.giftCertificateAmount)?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
				</div>
			</div>

			<!-- Shipping -->
			<div class="flex justify-between w-full text-sm my-1">
				<div>Shipping:</div>
				<span>{{ parseFloat(order?.shippingCostExTax)?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
			</div>

			<!-- Coupon Discount -->
			<div v-if="order?.couponDiscount" class="flex justify-between text-sm my-1">
				<div class="space-x-1">
					<span>Coupon</span>
				</div>
				<div>
					<span v-if="parseFloat(order?.couponDiscount) > 0"
						>-{{ parseFloat(order?.couponDiscount)?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span
					>
					<span v-else>{{ parseFloat(order?.couponDiscount)?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
				</div>
			</div>

			<!-- Texas State Sales Tax -->
			<div v-if="order?.totalTax" class="flex justify-between text-sm my-1">
				<span>Texas State Sales Tax:</span>
				<span>{{ parseFloat(order?.totalTax)?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
			</div>

			<!-- Store Credit -->
			<div v-if="parseFloat(order?.storeCreditAmount) > 0" class="flex justify-between w-full text-sm my-1">
				<div>Store Credit:</div>
				<span>-{{ parseFloat(order?.storeCreditAmount)?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
			</div>
		</div>

		<div class="my-8 px-2">
			<div class="flex justify-between items-center">
				<span class="text-base font-normal">Total (USD)</span>
				<span :class="totalClass">{{ parseFloat(order?.totalIncTax)?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		order: {
			type: Object,
			required: true,
		},
		displayedProducts: {
			type: Array,
			required: true,
		},
		totalClass: {
			type: String,
			default: 'text-2xl font-bold',
		},
		showFullCart: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		handleShowFullCart() {
			this.$emit('show-full-cart', !this.showFullCart)
		},
	},
}
</script>
